import { render, staticRenderFns } from "./CheckoutShippingWithdrawalPoints.vue?vue&type=template&id=ed076a8e&scoped=true&"
import script from "./CheckoutShippingWithdrawalPoints.vue?vue&type=script&lang=js&"
export * from "./CheckoutShippingWithdrawalPoints.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutShippingWithdrawalPoints.vue?vue&type=style&index=0&id=ed076a8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed076a8e",
  null
  
)

export default component.exports